import {
  fetchKratosLoginFlow,
  fetchKratosSettingsFlow,
  loginKratosPasskey,
  registerKratosPasskey,
  removeKratosPasskey,
} from '../api_client_portal/kratos'
import type { Resolvers } from '../generated/server/resolvers'

const KratosResolvers: Resolvers = {
  Query: {
    kratosSettingsFlow: (_parent, { flow_id }) => fetchKratosSettingsFlow(flow_id),
    kratosLoginFlow: () => fetchKratosLoginFlow(),
  },
  Mutation: {
    removeKratosPasskey: (_parent, { flow_id, csrf_token, passkey_remove }) =>
      removeKratosPasskey(flow_id, csrf_token, passkey_remove),
    registerKratosPasskey: (_parent, { flow_id, csrf_token, passkey_settings_register }) =>
      registerKratosPasskey(flow_id, csrf_token, passkey_settings_register),
    loginKratosPasskey: (_parent, { flow_id, csrf_token, passkey_login }) =>
      loginKratosPasskey(flow_id, csrf_token, passkey_login),
  },
}

export default KratosResolvers
